/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import i18n from './i18n'
import router from '@/router'
import pinia from '@/store'
import * as Sentry from '@sentry/vue';

// Types
import type { App } from 'vue'
import { isDevEnv } from '@/constants/config'
import { getRuntimeEnv } from '@/constants/runtimeConfig'

export const registerPlugins = (app: App): void => {
  app
    .use(i18n)
    .use(router)
    .use(pinia)

  Sentry.init({
    app,
    dsn: getRuntimeEnv('VITE_SENTRY_DSN', import.meta.env.VITE_SENTRY_DSN),
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    integrations: [
    ],
  });
}

export { registerComponents } from "@maru/hub-vuetify-components";
